import { shallowEqual } from 'shallow-equal-object';

/**
 * 値オブジェクトの抽象クラス
 */
export abstract class AbstractValueObject<T> {
  /** 値 */
  protected readonly val: T;

  protected constructor(value: T) {
    this.val = Object.freeze(value);
  }

  /**
   * 等しいか
   * @param vo 対象
   * @returns 同じか
   */
  equals(vo?: AbstractValueObject<T>): boolean {
    if (vo == null) {
      return false;
    }
    return shallowEqual(this.val, vo.val);
  }
}
